import React from 'react';
import { SupervisorAccountOutlined, Approval } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { INTERVIEW_LIST_PAGE_TEXT } from './lang';
import { INTERVIEW_DETAIL_MODULES } from './constants';
import { Sidebar, type SidebarData, Button } from '../../../components';
import { SidebarViewPoint } from '../../Application/components';

export type InterviewDetailSidebarProps = {
  enableSubmit: boolean;
  onSubmitNomination: () => void;
};
export const InterviewDetailSidebar: React.FunctionComponent<
  InterviewDetailSidebarProps
> = props => {
  const { onSubmitNomination, enableSubmit } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  let activatedModuleId = searchParams.get('am') as INTERVIEW_DETAIL_MODULES;
  if (!Object.values(INTERVIEW_DETAIL_MODULES).includes(activatedModuleId)) {
    activatedModuleId = INTERVIEW_DETAIL_MODULES.INTERVIEW_DETAIL;
  }

  const sidebarData: SidebarData[] = [
    {
      id: INTERVIEW_DETAIL_MODULES.APPLICANT_PARTICULARS,
      name: INTERVIEW_LIST_PAGE_TEXT.APPLICANT_PARTICULARS,
      icon: <SupervisorAccountOutlined />,
    },
    {
      id: INTERVIEW_DETAIL_MODULES.INTERVIEW_DETAIL,
      name: INTERVIEW_LIST_PAGE_TEXT.INTERVIEW_REPORT,
      icon: <Approval />,
    },
  ];

  const handleChangeActivated = (activatedId: string): void => {
    searchParams.set('am', activatedId);

    // Update the URL with new Module
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  const handleBack = (): void => {
    navigate('/internal/interview-homepage');
  };

  return (
    <SidebarViewPoint>
      <Sidebar
        defaultActivatedId={INTERVIEW_DETAIL_MODULES.APPLICANT_PARTICULARS}
        sidebarData={sidebarData}
        barInnerWidth="16rem"
        manuallyActivatedId={activatedModuleId}
        onChangeActivated={handleChangeActivated}
      />
      <div className="flex justify-center mt-6">
        <Button variant="outlined" onClick={handleBack}>
          {INTERVIEW_LIST_PAGE_TEXT.BACK}
        </Button>
        {enableSubmit && (
          <Button
            style={{ marginLeft: '1.25rem' }}
            variant="contained"
            onClick={onSubmitNomination}
          >
            {INTERVIEW_LIST_PAGE_TEXT.SUBMIT}
          </Button>
        )}
      </div>
    </SidebarViewPoint>
  );
};
